/**
 * Display helpers for the capacity assessment (does SCE's outlook support the
 * applicant's planned deployment). Status keys mirror the backend
 * regulator_module.services.capacity_assessment module.
 */

export const ASSESSMENT_STATUS_META = {
  supported: {
    label: 'Supported',
    badgeClass: 'bg-green-100 text-green-800 border border-green-200',
    dotClass: 'bg-green-500',
    tooltipSummary: 'Outlook capacity supports the planned deployment.',
  },
  marginal: {
    label: 'Marginal',
    badgeClass: 'bg-amber-100 text-amber-800 border border-amber-200',
    dotClass: 'bg-amber-500',
    tooltipSummary: 'Capacity is close to the requirement (within 10% headroom).',
  },
  not_supported: {
    label: 'Not supported',
    badgeClass: 'bg-red-100 text-red-800 border border-red-200',
    dotClass: 'bg-red-500',
    tooltipSummary: 'Available capacity is below the planned deployment.',
  },
  beyond_horizon: {
    label: 'Beyond outlook horizon',
    badgeClass: 'bg-gray-100 text-gray-700 border border-gray-200',
    dotClass: 'bg-gray-400',
    tooltipSummary: 'Expected year is beyond the available outlook horizon.',
  },
  outlook_unavailable: {
    label: 'Outlook unavailable',
    badgeClass: 'bg-gray-100 text-gray-700 border border-gray-200',
    dotClass: 'bg-gray-400',
    tooltipSummary: 'No usable per-year outlook is available for this location.',
  },
  not_provided: {
    label: 'Not provided',
    badgeClass: 'bg-gray-50 text-gray-500 border border-gray-200',
    dotClass: 'bg-gray-300',
    tooltipSummary: 'Expected capacity or expected year is missing.',
  },
};

const LABEL_TO_META = Object.values(ASSESSMENT_STATUS_META).reduce((acc, meta) => {
  acc[meta.label] = meta;
  return acc;
}, {});

export const getAssessmentMeta = (status) =>
  ASSESSMENT_STATUS_META[status] || ASSESSMENT_STATUS_META.not_provided;

export const getAssessmentMetaByLabel = (label) =>
  LABEL_TO_META[label] || null;

const BINDING_CONSTRAINT_LABELS = {
  circuit: 'circuit',
  substation: 'substation',
  a_bank: 'A Bank',
};

export const formatBindingConstraint = (binding) =>
  BINDING_CONSTRAINT_LABELS[binding] || binding || null;
